import React, { Component } from 'react';
import ListingScreen from '../../custom/listingScreen/ListingScreen';
import ClientService from '../../../services/clients/ClientService';
import SearchIcon from '@material-ui/icons/Search';
import DevisIcon from '@material-ui/icons/AddShoppingCart';
import menuData from '../MenuDatas';

class ClientList extends Component {


    path = menuData.clientEdit.path;
    tableColumnsAction = [{ "icon": <SearchIcon />, "label": "Visualiser le client", "className": "dataListModifier", "url": this.path, "typeAction": "open/edit" },
        { "icon": <DevisIcon />, "label": "Créer un devis", "className": "creerDevis dataListModifier", "url": menuData.devisEdit.path+"/client", "typeAction": "open/edit" }]
    tableColumns = [{ "label": "Numéro", "className": "dataListNumero" }, { "label": "Type", "className": "dataListType" }, { "label": "Nom", "className": "dataListNom" }];
    labelRecherche = "Rechercher par numéro, nom ou prénom";
    labelCreation = "Créer un nouveau client";

    getDataService(critere) {
        var clientService = new ClientService();
        return clientService.getAll(critere);
    }

    render() {
        return (
            <ListingScreen
                tableColumnsAction={this.tableColumnsAction}
                tableColumns={this.tableColumns}
                service={this.getDataService}
                path={this.path}
                addButton={true}
                labelRecherche={this.labelRecherche}
                labelCreation={this.labelCreation}
            />);
    }
}

export default ClientList;


// WEBPACK FOOTER //
// ./src/components/content/clientList/ClientList.js